<template>
	<div class="rounded-xl pa-4 offer-filter-dashboard container">
		<div cols="12" class="offer-filter-dashboard__title item1" v-if="isDesktopDevice">
			Filter your Offers
		</div>

		<div class="item2">
			<DeviceFilterComponent></DeviceFilterComponent>
		</div>

		<div class="item3">
			<OfferSearch class="w-100"></OfferSearch>
		</div>

		<div class="item4" v-if="!isMobileDevice">
			<OfferNetworkSelector class="w-100"></OfferNetworkSelector>
		</div>

		<div class="item5" v-if="!isMobileDevice">
			<OfferSortOptions class="w-100"></OfferSortOptions>
		</div>

		<v-divider v-if="isTabletDevice" class="item6" />

		<div class="w-100 d-flex flex-row item7 overflow-x-scroll" v-if="!isMobileDevice">
			<OfferCategoryButtons></OfferCategoryButtons>
		</div>
	</div>
</template>



<script setup>
import OfferSearch from "./Offer-Search.vue";
import OfferSortOptions from "./Offer-Sort-Options.vue";
import OfferCategoryButtons from "./Offer-Category-Buttons.vue";
import OfferNetworkSelector from "./Offer-Network-Selector.vue";
import { isMobile, isDesktop, isTablet } from "@/utils/utils.ts";
import DeviceFilterComponent from "@/components/Common/Device-Filter-Component.vue";


const isMobileDevice = isMobile();
const isTabletDevice = isTablet();
const isDesktopDevice = isDesktop();

</script>



<style scoped lang="scss">
.offer-filter-dashboard {
	width: 96%;
	margin: auto;
	height: 100%;
	background: rgba(35, 38, 47, 0.60);
	box-shadow: 0px 4px 45px 0px vars.get-map-value(vars.$offers-page, dashboard-controls-box-shadow);
	backdrop-filter: blur(10px);
	z-index: -1;

	&__title {
		text-align: center;
		font-size: 18px;
		font-weight: 700;
	}
}

.loading-container {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	width: 100%;
	position: absolute;
	top: 0;
	left: 0;
}

.container {
	display: grid;
	grid-template-rows: 0.5fr 1fr 1fr;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	gap: 16px 16px;
}

.item1 {
	grid-row: span 1;
	grid-column: span 4;
}

.item2 {
	grid-row: span 1;
	grid-column: span 1;
}

.item3 {
	grid-row: span 1;
	grid-column: span 1;
}

.item4 {
	grid-row: span 1;
	grid-column: span 1;
}

.item7 {
	grid-row: span 1;
	grid-column: span 3;
}

.item8 {
	grid-row: span 1;
	grid-column: span 1;
}

@media screen and (max-width: 600px) {
	.container {
		display: grid;
		grid-template-rows: 1fr 0.7fr;
		grid-template-columns: 1fr 1fr;
	}

	.item2 {
		grid-row: 1 / 2;
		grid-column: 1 / 2;
		align-self: end;
	}

	.item3 {
		grid-row: 2 / 3;
		grid-column: 1 / 3;
		align-self: end;
	}

	.item8 {
		grid-row: 1 / 2;
		grid-column: 2 / 3;
		align-self: end;
	}
}

@media screen and (min-width: 600px) and (max-width: 960px) {
	.container {
		display: grid;
		grid-template-rows: 1fr 2px 1fr 1fr;
		grid-template-columns: 1fr 1fr 1fr;
		grid-gap: 24px 16px;
	}

	.item1 {
		grid-row: 1 / 2;
		grid-column: 1 / 3;
	}

	.item2 {
		grid-row: 1 / 2;
		grid-column: 1 / 3;
	}

	.item3 {
		grid-row: 3 / 4;
		grid-column: 1 / 2;
	}

	.item4 {
		grid-row: 3 / 4;
		grid-column: 2 / 3;
	}

	.item5 {
		grid-row: 3 / 4;
		grid-column: 3 / 4;
	}

	.item6 {
		grid-row: 2 / 3;
		grid-column: 1 / 4;
	}

	.item8 {
		grid-row: 1 / 2;
		grid-column: 3 / 4;
	}
}

.overflow-x-scroll {
	overflow-x: auto;
	scrollbar-width: none;

	@media screen and (max-width: 600px) {
		.overflow-x-scroll {
			overflow-x: hidden;
		}
	}
}
</style>
